// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.file-manager {
         
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
          color: #333;
         
          margin: 0 auto;
        }
        
        h2 {
          margin: 0 0 5px 0;
          color: #2c3e50;
        }
        
        .subtitle {
          color: #7f8c8d;
          margin: 0 0 25px 0;
        }
        
        .stats-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 20px;
          margin-bottom: 30px;
        }
        
        .stat-card {
          background: white;
          border-radius: 8px;
          padding: 20px;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
          display: flex;
          align-items: center;
        }
        
        .stat-icon {
          color: #6b7280; /* Tailwind gray-500 */
          font-size: 2em;
          margin-bottom: 8px;
          margin-right: 15px;
        }
        
        .stat-content h3 {
          margin: 0;
          font-size: 1.8rem;
          color: #2c3e50;
        }
        
        .stat-content p {
          margin: 5px 0 0 0;
          color: #7f8c8d;
        }
        
        .upload-section {
          background: white;
          border-radius: 8px;
          padding: 20px;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
          margin-bottom: 20px;
        }
        
        .upload-section h3 {
          margin: 0 0 15px 0;
          color: #2c3e50;
        }
        
        .upload-area {
          border: 2px dashed #ddd;
          border-radius: 8px;
          padding: 20px;
          text-align: center;
        }
        
        .file-input {
          width: 100%;
          margin-bottom: 15px;
        }
        
        .upload-button {
          background: #3498db;
          color: white;
          border: none;
          padding: 10px 20px;
          border-radius: 4px;
          cursor: pointer;
          margin-top: 15px;
        }
        
        .upload-button:hover {
          background: #2980b9;
        }
        
        .filters-section {
          display: flex;
          justify-content: space-between;
          margin-bottom: 20px;
          flex-wrap: wrap;
          gap: 15px;
        }
        
        .search-box input {
          padding: 10px;
          border: 1px solid #ddd;
          border-radius: 4px;
          width: 250px;
        }
        
        .filter-group {
          display: flex;
          gap: 10px;
        }
        
        .filter-group select {
          padding: 10px;
          border: 1px solid #ddd;
          border-radius: 4px;
          background: white;
        }
        
        .files-table-container {
          background: white;
          border-radius: 8px;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
          overflow: hidden;
        }
        
        .loading, .no-files {
          padding: 40px;
          text-align: center;
          color: #7f8c8d;
        }
        
        .files-table {
          width: 100%;
          border-collapse: collapse;
        }
        
        .files-table th {
          background: #f8f9fa;
          padding: 8px;
         
          font-weight: 600;
          color: #2c3e50;
          border-bottom: 1px solid #ddd;
        }
        
        .files-table td {
          padding: 8px;
          border-bottom: 1px solid #eee;
        }
        
        .files-table tr:hover {
          background: #f8f9fa;
        }
        
        .file-info {
          display: flex;
          align-items: flex-start;
        }
        
        .file-icon {
          color: #6b7280; /* Tailwind gray-500 */
          font-size: 1.5em;
          margin-right: 10px;
          vertical-align: middle;
        }
        
        .file-title {
          font-weight: 600;
          color: #2c3e50;
        }
        
        .file-name {
          font-size: 0.9rem;
          color: #7f8c8d;
          margin: 2px 0;
        }
        
        .file-tags {
          display: flex;
          flex-wrap: wrap;
          gap: 5px;
          margin-top: 5px;
        }
        
        .tag {
          background: #e8f4fd;
          color: #3498db;
          padding: 2px 8px;
          border-radius: 12px;
          font-size: 0.8rem;
        }
        
        .vault.internal {
          color: #27ae60;
          font-weight: 600;
        }
        
        .vault.external {
          color: #3498db;
          font-weight: 600;
        }
        
        .status.active {
          color: #27ae60;
          font-weight: 600;
        }
        
        .status.processing {
          color: #f39c12;
          font-weight: 600;
        }
        
        .access.public {
          color: #27ae60;
          font-weight: 600;
        }
        
        .access.restricted {
          color: #f39c12;
          font-weight: 600;
        }
        
        .access.confidential {
          color: #e74c3c;
          font-weight: 600;
        }
        
        .uploader {
          font-size: 0.8rem;
          color: #7f8c8d;
          margin-top: 3px;
        }
        
        .actions {
          display: flex;
          gap: 8px;
        }
        
        .actions button {
          background: none;
          border: 1px solid #ddd;
          border-radius: 4px;
          padding: 5px 8px;
          cursor: pointer;
          font-size: 1rem;
        }
        
        .actions button:hover {
          background: #f8f9fa;
        }
        
        .delete-btn:hover {
          color: #e74c3c;
          border-color: #e74c3c;
        }
        
        @media (max-width: 768px) {
          .filters-section {
            flex-direction: column;
          }
          
          .search-box input {
            width: 100%;
          }
          
          .filter-group {
            width: 100%;
            justify-content: space-between;
          }
          
          .files-table {
            display: block;
            overflow-x: auto;
          }
        }


        .file-manager-container {
  padding: 20px;
  max-width: 100%;
  margin: 100px auto 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.file-manager-header {
  margin-bottom: 24px;
}

.file-manager-header h2 {
  color: #2c3e50;
  margin: 0 0 8px 0;
  font-weight: 600;
}

.subtitle {
  color: #7f8c8d;
  margin: 0;
  font-size: 16px;
}

.controls-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 15px;
}

.search-box {
  position: relative;
  display: flex;
  align-items: center;
  flex: 1 1;
  min-width: 300px;
  max-width: 500px;
}

.search-icon {
  position: absolute;
  left: 12px;
  color: #95a5a6;
}

.search-box input {
  width: 100%;
  padding: 10px 15px 10px 40px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.3s;
}

.search-box input:focus {
  outline: none;
  border-color: #3498db;
  box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.2);
}

.controls-right {
  display: flex;
  gap: 10px;
}

.refresh-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background-color: #ecf0f1;
  border: 1px solid #ddd;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s;
}

.refresh-btn:hover:not(:disabled) {
  background-color: #dfe6e9;
}

.refresh-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.spinning {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.table-container {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

.table-responsive {
  overflow-x: auto;
  width: 100%;
}

.messages-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 800px;
}

.messages-table th {
  background-color: #f8f9fa;
  padding: 12px 15px;
  text-align: left;
  font-weight: 600;
  color: #2c3e50;
  border-bottom: 2px solid #e9ecef;
  cursor: pointer;
  transition: background-color 0.3s;
  position: relative;
}

.messages-table th:hover {
  background-color: #e9ecef;
}

.column-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.sort-indicator {
  margin-left: 5px;
  font-weight: bold;
}

.messages-table td {
  padding: 12px 15px;
  border-bottom: 1px solid #e9ecef;
  vertical-align: top;
  font-size: 14px;
  color: #34495e;
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.messages-table tr:hover {
  background-color: #f8f9fa;
}

.array-container {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.array-item {
  background-color: #e3f2fd;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  color: #1976d2;
}

.truncate-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.action-buttons {
  display: flex;
  gap: 8px;
}

.action-btn {
  padding: 6px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.action-btn.view {
  background-color: #e3f2fd;
  color: #1976d2;
}

.action-btn.download {
  background-color: #e8f5e9;
  color: #388e3c;
}

.action-btn.delete {
  background-color: #ffebee;
  color: #d32f2f;
}

.action-btn:hover {
  opacity: 0.8;
  transform: scale(1.05);
}

.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(31, 124, 80, 0.2);
  border-top: 4px solid #1f7c50;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 16px;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  color: #95a5a6;
  text-align: center;
}

.empty-state h3 {
  margin: 16px 0 8px;
  color: #7f8c8d;
}

.pagination {
  display: flex;
  justify-content: center;
  padding: 20px;
  gap: 8px;
}

.pagination button {
  padding: 8px 12px;
  border: 1px solid #ddd;
  background-color: white;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
}

.pagination button:hover:not(:disabled):not(.active) {
  background-color: #f1f1f1;
}

.pagination button.active {
  background-color: #3498db;
  color: white;
  border-color: #3498db;
}

.pagination button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.table-info {
  padding: 0 20px 20px;
  text-align: center;
  color: #7f8c8d;
  font-size: 14px;
}

@media (max-width: 768px) {
  .file-manager-container {
    padding: 15px;
    margin-top: 80px;
  }
  
  .controls-section {
    flex-direction: column;
    align-items: stretch;
  }
  
  .search-box {
    min-width: 100%;
  }
  
  .messages-table th, 
  .messages-table td {
    padding: 8px 10px;
    font-size: 13px;
  }
  
  .action-buttons {
    flex-direction: column;
    gap: 4px;
  }
}

.bareedy-card {
  transition: box-shadow 0.2s;
}
.bareedy-card:hover {
  box-shadow: 0 4px 16px rgba(25, 118, 210, 0.12);
}
.action-btn {
  cursor: pointer;
  transition: background 0.2s;
}
.action-btn:hover {
  filter: brightness(0.95);
}`, "",{"version":3,"sources":["webpack://./src/pages/OnBoxMessage/FileManager.css"],"names":[],"mappings":"AAAA;;UAEU,8EAA8E;UAC9E,WAAW;;UAEX,cAAc;QAChB;;QAEA;UACE,iBAAiB;UACjB,cAAc;QAChB;;QAEA;UACE,cAAc;UACd,kBAAkB;QACpB;;QAEA;UACE,aAAa;UACb,2DAA2D;UAC3D,SAAS;UACT,mBAAmB;QACrB;;QAEA;UACE,iBAAiB;UACjB,kBAAkB;UAClB,aAAa;UACb,yCAAyC;UACzC,aAAa;UACb,mBAAmB;QACrB;;QAEA;UACE,cAAc,EAAE,sBAAsB;UACtC,cAAc;UACd,kBAAkB;UAClB,kBAAkB;QACpB;;QAEA;UACE,SAAS;UACT,iBAAiB;UACjB,cAAc;QAChB;;QAEA;UACE,iBAAiB;UACjB,cAAc;QAChB;;QAEA;UACE,iBAAiB;UACjB,kBAAkB;UAClB,aAAa;UACb,yCAAyC;UACzC,mBAAmB;QACrB;;QAEA;UACE,kBAAkB;UAClB,cAAc;QAChB;;QAEA;UACE,uBAAuB;UACvB,kBAAkB;UAClB,aAAa;UACb,kBAAkB;QACpB;;QAEA;UACE,WAAW;UACX,mBAAmB;QACrB;;QAEA;UACE,mBAAmB;UACnB,YAAY;UACZ,YAAY;UACZ,kBAAkB;UAClB,kBAAkB;UAClB,eAAe;UACf,gBAAgB;QAClB;;QAEA;UACE,mBAAmB;QACrB;;QAEA;UACE,aAAa;UACb,8BAA8B;UAC9B,mBAAmB;UACnB,eAAe;UACf,SAAS;QACX;;QAEA;UACE,aAAa;UACb,sBAAsB;UACtB,kBAAkB;UAClB,YAAY;QACd;;QAEA;UACE,aAAa;UACb,SAAS;QACX;;QAEA;UACE,aAAa;UACb,sBAAsB;UACtB,kBAAkB;UAClB,iBAAiB;QACnB;;QAEA;UACE,iBAAiB;UACjB,kBAAkB;UAClB,yCAAyC;UACzC,gBAAgB;QAClB;;QAEA;UACE,aAAa;UACb,kBAAkB;UAClB,cAAc;QAChB;;QAEA;UACE,WAAW;UACX,yBAAyB;QAC3B;;QAEA;UACE,mBAAmB;UACnB,YAAY;;UAEZ,gBAAgB;UAChB,cAAc;UACd,6BAA6B;QAC/B;;QAEA;UACE,YAAY;UACZ,6BAA6B;QAC/B;;QAEA;UACE,mBAAmB;QACrB;;QAEA;UACE,aAAa;UACb,uBAAuB;QACzB;;QAEA;UACE,cAAc,EAAE,sBAAsB;UACtC,gBAAgB;UAChB,kBAAkB;UAClB,sBAAsB;QACxB;;QAEA;UACE,gBAAgB;UAChB,cAAc;QAChB;;QAEA;UACE,iBAAiB;UACjB,cAAc;UACd,aAAa;QACf;;QAEA;UACE,aAAa;UACb,eAAe;UACf,QAAQ;UACR,eAAe;QACjB;;QAEA;UACE,mBAAmB;UACnB,cAAc;UACd,gBAAgB;UAChB,mBAAmB;UACnB,iBAAiB;QACnB;;QAEA;UACE,cAAc;UACd,gBAAgB;QAClB;;QAEA;UACE,cAAc;UACd,gBAAgB;QAClB;;QAEA;UACE,cAAc;UACd,gBAAgB;QAClB;;QAEA;UACE,cAAc;UACd,gBAAgB;QAClB;;QAEA;UACE,cAAc;UACd,gBAAgB;QAClB;;QAEA;UACE,cAAc;UACd,gBAAgB;QAClB;;QAEA;UACE,cAAc;UACd,gBAAgB;QAClB;;QAEA;UACE,iBAAiB;UACjB,cAAc;UACd,eAAe;QACjB;;QAEA;UACE,aAAa;UACb,QAAQ;QACV;;QAEA;UACE,gBAAgB;UAChB,sBAAsB;UACtB,kBAAkB;UAClB,gBAAgB;UAChB,eAAe;UACf,eAAe;QACjB;;QAEA;UACE,mBAAmB;QACrB;;QAEA;UACE,cAAc;UACd,qBAAqB;QACvB;;QAEA;UACE;YACE,sBAAsB;UACxB;;UAEA;YACE,WAAW;UACb;;UAEA;YACE,WAAW;YACX,8BAA8B;UAChC;;UAEA;YACE,cAAc;YACd,gBAAgB;UAClB;QACF;;;QAGA;EACN,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,4DAA4D;AAC9D;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAO;EACP,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;AACF;;AAEA;EACE,2BAA2B;AAC7B;AACA;EACE,+CAA+C;AACjD;AACA;EACE,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,wBAAwB;AAC1B","sourcesContent":[".file-manager {\r\n         \r\n          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\r\n          color: #333;\r\n         \r\n          margin: 0 auto;\r\n        }\r\n        \r\n        h2 {\r\n          margin: 0 0 5px 0;\r\n          color: #2c3e50;\r\n        }\r\n        \r\n        .subtitle {\r\n          color: #7f8c8d;\r\n          margin: 0 0 25px 0;\r\n        }\r\n        \r\n        .stats-grid {\r\n          display: grid;\r\n          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\r\n          gap: 20px;\r\n          margin-bottom: 30px;\r\n        }\r\n        \r\n        .stat-card {\r\n          background: white;\r\n          border-radius: 8px;\r\n          padding: 20px;\r\n          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\r\n          display: flex;\r\n          align-items: center;\r\n        }\r\n        \r\n        .stat-icon {\r\n          color: #6b7280; /* Tailwind gray-500 */\r\n          font-size: 2em;\r\n          margin-bottom: 8px;\r\n          margin-right: 15px;\r\n        }\r\n        \r\n        .stat-content h3 {\r\n          margin: 0;\r\n          font-size: 1.8rem;\r\n          color: #2c3e50;\r\n        }\r\n        \r\n        .stat-content p {\r\n          margin: 5px 0 0 0;\r\n          color: #7f8c8d;\r\n        }\r\n        \r\n        .upload-section {\r\n          background: white;\r\n          border-radius: 8px;\r\n          padding: 20px;\r\n          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\r\n          margin-bottom: 20px;\r\n        }\r\n        \r\n        .upload-section h3 {\r\n          margin: 0 0 15px 0;\r\n          color: #2c3e50;\r\n        }\r\n        \r\n        .upload-area {\r\n          border: 2px dashed #ddd;\r\n          border-radius: 8px;\r\n          padding: 20px;\r\n          text-align: center;\r\n        }\r\n        \r\n        .file-input {\r\n          width: 100%;\r\n          margin-bottom: 15px;\r\n        }\r\n        \r\n        .upload-button {\r\n          background: #3498db;\r\n          color: white;\r\n          border: none;\r\n          padding: 10px 20px;\r\n          border-radius: 4px;\r\n          cursor: pointer;\r\n          margin-top: 15px;\r\n        }\r\n        \r\n        .upload-button:hover {\r\n          background: #2980b9;\r\n        }\r\n        \r\n        .filters-section {\r\n          display: flex;\r\n          justify-content: space-between;\r\n          margin-bottom: 20px;\r\n          flex-wrap: wrap;\r\n          gap: 15px;\r\n        }\r\n        \r\n        .search-box input {\r\n          padding: 10px;\r\n          border: 1px solid #ddd;\r\n          border-radius: 4px;\r\n          width: 250px;\r\n        }\r\n        \r\n        .filter-group {\r\n          display: flex;\r\n          gap: 10px;\r\n        }\r\n        \r\n        .filter-group select {\r\n          padding: 10px;\r\n          border: 1px solid #ddd;\r\n          border-radius: 4px;\r\n          background: white;\r\n        }\r\n        \r\n        .files-table-container {\r\n          background: white;\r\n          border-radius: 8px;\r\n          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\r\n          overflow: hidden;\r\n        }\r\n        \r\n        .loading, .no-files {\r\n          padding: 40px;\r\n          text-align: center;\r\n          color: #7f8c8d;\r\n        }\r\n        \r\n        .files-table {\r\n          width: 100%;\r\n          border-collapse: collapse;\r\n        }\r\n        \r\n        .files-table th {\r\n          background: #f8f9fa;\r\n          padding: 8px;\r\n         \r\n          font-weight: 600;\r\n          color: #2c3e50;\r\n          border-bottom: 1px solid #ddd;\r\n        }\r\n        \r\n        .files-table td {\r\n          padding: 8px;\r\n          border-bottom: 1px solid #eee;\r\n        }\r\n        \r\n        .files-table tr:hover {\r\n          background: #f8f9fa;\r\n        }\r\n        \r\n        .file-info {\r\n          display: flex;\r\n          align-items: flex-start;\r\n        }\r\n        \r\n        .file-icon {\r\n          color: #6b7280; /* Tailwind gray-500 */\r\n          font-size: 1.5em;\r\n          margin-right: 10px;\r\n          vertical-align: middle;\r\n        }\r\n        \r\n        .file-title {\r\n          font-weight: 600;\r\n          color: #2c3e50;\r\n        }\r\n        \r\n        .file-name {\r\n          font-size: 0.9rem;\r\n          color: #7f8c8d;\r\n          margin: 2px 0;\r\n        }\r\n        \r\n        .file-tags {\r\n          display: flex;\r\n          flex-wrap: wrap;\r\n          gap: 5px;\r\n          margin-top: 5px;\r\n        }\r\n        \r\n        .tag {\r\n          background: #e8f4fd;\r\n          color: #3498db;\r\n          padding: 2px 8px;\r\n          border-radius: 12px;\r\n          font-size: 0.8rem;\r\n        }\r\n        \r\n        .vault.internal {\r\n          color: #27ae60;\r\n          font-weight: 600;\r\n        }\r\n        \r\n        .vault.external {\r\n          color: #3498db;\r\n          font-weight: 600;\r\n        }\r\n        \r\n        .status.active {\r\n          color: #27ae60;\r\n          font-weight: 600;\r\n        }\r\n        \r\n        .status.processing {\r\n          color: #f39c12;\r\n          font-weight: 600;\r\n        }\r\n        \r\n        .access.public {\r\n          color: #27ae60;\r\n          font-weight: 600;\r\n        }\r\n        \r\n        .access.restricted {\r\n          color: #f39c12;\r\n          font-weight: 600;\r\n        }\r\n        \r\n        .access.confidential {\r\n          color: #e74c3c;\r\n          font-weight: 600;\r\n        }\r\n        \r\n        .uploader {\r\n          font-size: 0.8rem;\r\n          color: #7f8c8d;\r\n          margin-top: 3px;\r\n        }\r\n        \r\n        .actions {\r\n          display: flex;\r\n          gap: 8px;\r\n        }\r\n        \r\n        .actions button {\r\n          background: none;\r\n          border: 1px solid #ddd;\r\n          border-radius: 4px;\r\n          padding: 5px 8px;\r\n          cursor: pointer;\r\n          font-size: 1rem;\r\n        }\r\n        \r\n        .actions button:hover {\r\n          background: #f8f9fa;\r\n        }\r\n        \r\n        .delete-btn:hover {\r\n          color: #e74c3c;\r\n          border-color: #e74c3c;\r\n        }\r\n        \r\n        @media (max-width: 768px) {\r\n          .filters-section {\r\n            flex-direction: column;\r\n          }\r\n          \r\n          .search-box input {\r\n            width: 100%;\r\n          }\r\n          \r\n          .filter-group {\r\n            width: 100%;\r\n            justify-content: space-between;\r\n          }\r\n          \r\n          .files-table {\r\n            display: block;\r\n            overflow-x: auto;\r\n          }\r\n        }\r\n\r\n\r\n        .file-manager-container {\r\n  padding: 20px;\r\n  max-width: 100%;\r\n  margin: 100px auto 0;\r\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n\r\n.file-manager-header {\r\n  margin-bottom: 24px;\r\n}\r\n\r\n.file-manager-header h2 {\r\n  color: #2c3e50;\r\n  margin: 0 0 8px 0;\r\n  font-weight: 600;\r\n}\r\n\r\n.subtitle {\r\n  color: #7f8c8d;\r\n  margin: 0;\r\n  font-size: 16px;\r\n}\r\n\r\n.controls-section {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 20px;\r\n  flex-wrap: wrap;\r\n  gap: 15px;\r\n}\r\n\r\n.search-box {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n  flex: 1;\r\n  min-width: 300px;\r\n  max-width: 500px;\r\n}\r\n\r\n.search-icon {\r\n  position: absolute;\r\n  left: 12px;\r\n  color: #95a5a6;\r\n}\r\n\r\n.search-box input {\r\n  width: 100%;\r\n  padding: 10px 15px 10px 40px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 6px;\r\n  font-size: 14px;\r\n  transition: border-color 0.3s;\r\n}\r\n\r\n.search-box input:focus {\r\n  outline: none;\r\n  border-color: #3498db;\r\n  box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.2);\r\n}\r\n\r\n.controls-right {\r\n  display: flex;\r\n  gap: 10px;\r\n}\r\n\r\n.refresh-btn {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 8px 16px;\r\n  background-color: #ecf0f1;\r\n  border: 1px solid #ddd;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  transition: all 0.3s;\r\n}\r\n\r\n.refresh-btn:hover:not(:disabled) {\r\n  background-color: #dfe6e9;\r\n}\r\n\r\n.refresh-btn:disabled {\r\n  opacity: 0.7;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.spinning {\r\n  animation: spin 1s linear infinite;\r\n}\r\n\r\n@keyframes spin {\r\n  from { transform: rotate(0deg); }\r\n  to { transform: rotate(360deg); }\r\n}\r\n\r\n.table-container {\r\n  background: white;\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\r\n  overflow: hidden;\r\n}\r\n\r\n.table-responsive {\r\n  overflow-x: auto;\r\n  width: 100%;\r\n}\r\n\r\n.messages-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  min-width: 800px;\r\n}\r\n\r\n.messages-table th {\r\n  background-color: #f8f9fa;\r\n  padding: 12px 15px;\r\n  text-align: left;\r\n  font-weight: 600;\r\n  color: #2c3e50;\r\n  border-bottom: 2px solid #e9ecef;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s;\r\n  position: relative;\r\n}\r\n\r\n.messages-table th:hover {\r\n  background-color: #e9ecef;\r\n}\r\n\r\n.column-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n\r\n.sort-indicator {\r\n  margin-left: 5px;\r\n  font-weight: bold;\r\n}\r\n\r\n.messages-table td {\r\n  padding: 12px 15px;\r\n  border-bottom: 1px solid #e9ecef;\r\n  vertical-align: top;\r\n  font-size: 14px;\r\n  color: #34495e;\r\n  max-width: 300px;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.messages-table tr:hover {\r\n  background-color: #f8f9fa;\r\n}\r\n\r\n.array-container {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 4px;\r\n}\r\n\r\n.array-item {\r\n  background-color: #e3f2fd;\r\n  padding: 2px 6px;\r\n  border-radius: 4px;\r\n  font-size: 12px;\r\n  color: #1976d2;\r\n}\r\n\r\n.truncate-text {\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.action-buttons {\r\n  display: flex;\r\n  gap: 8px;\r\n}\r\n\r\n.action-btn {\r\n  padding: 6px;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  transition: all 0.3s;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.action-btn.view {\r\n  background-color: #e3f2fd;\r\n  color: #1976d2;\r\n}\r\n\r\n.action-btn.download {\r\n  background-color: #e8f5e9;\r\n  color: #388e3c;\r\n}\r\n\r\n.action-btn.delete {\r\n  background-color: #ffebee;\r\n  color: #d32f2f;\r\n}\r\n\r\n.action-btn:hover {\r\n  opacity: 0.8;\r\n  transform: scale(1.05);\r\n}\r\n\r\n.loading-state {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 40px;\r\n}\r\n\r\n.spinner {\r\n  width: 40px;\r\n  height: 40px;\r\n  border: 4px solid rgba(31, 124, 80, 0.2);\r\n  border-top: 4px solid #1f7c50;\r\n  border-radius: 50%;\r\n  animation: spin 1s linear infinite;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.empty-state {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 40px;\r\n  color: #95a5a6;\r\n  text-align: center;\r\n}\r\n\r\n.empty-state h3 {\r\n  margin: 16px 0 8px;\r\n  color: #7f8c8d;\r\n}\r\n\r\n.pagination {\r\n  display: flex;\r\n  justify-content: center;\r\n  padding: 20px;\r\n  gap: 8px;\r\n}\r\n\r\n.pagination button {\r\n  padding: 8px 12px;\r\n  border: 1px solid #ddd;\r\n  background-color: white;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  transition: all 0.3s;\r\n}\r\n\r\n.pagination button:hover:not(:disabled):not(.active) {\r\n  background-color: #f1f1f1;\r\n}\r\n\r\n.pagination button.active {\r\n  background-color: #3498db;\r\n  color: white;\r\n  border-color: #3498db;\r\n}\r\n\r\n.pagination button:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.table-info {\r\n  padding: 0 20px 20px;\r\n  text-align: center;\r\n  color: #7f8c8d;\r\n  font-size: 14px;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .file-manager-container {\r\n    padding: 15px;\r\n    margin-top: 80px;\r\n  }\r\n  \r\n  .controls-section {\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n  }\r\n  \r\n  .search-box {\r\n    min-width: 100%;\r\n  }\r\n  \r\n  .messages-table th, \r\n  .messages-table td {\r\n    padding: 8px 10px;\r\n    font-size: 13px;\r\n  }\r\n  \r\n  .action-buttons {\r\n    flex-direction: column;\r\n    gap: 4px;\r\n  }\r\n}\r\n\r\n.bareedy-card {\r\n  transition: box-shadow 0.2s;\r\n}\r\n.bareedy-card:hover {\r\n  box-shadow: 0 4px 16px rgba(25, 118, 210, 0.12);\r\n}\r\n.action-btn {\r\n  cursor: pointer;\r\n  transition: background 0.2s;\r\n}\r\n.action-btn:hover {\r\n  filter: brightness(0.95);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
